import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import logo from "../assets/images/logo.png";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const Navbar = () => {
  const navigate = useNavigate();
  const { logout, currentUser } = useAuth();
  const [user, setUser] = useState({ name: "User" });

  useEffect(() => {
    // Safely get user from localStorage or context
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      } else if (currentUser) {
        // Fallback to context if available
        setUser(currentUser);
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      // Keep default user
    }
  }, [currentUser]);

  // useEffect(() => {
  //   // Initialize Bootstrap dropdowns when component mounts
  //   if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  //     // Check if Bootstrap is available
  //     if (window.bootstrap) {
  //       // Initialize all dropdowns on the page
  //       const dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
  //       dropdownElementList.map(function (dropdownToggleEl) {
  //         return new window.bootstrap.Dropdown(dropdownToggleEl);
  //       });
  //     }
  //   }
  // }, []);

  const handleLogout = async () => {
    try {
      // Use the new logout function from auth context
      await logout(() => {
        navigate("/login");
      });
    } catch (error) {
      console.error("Logout failed:", error);
      // Even if API call fails, we should still redirect to login
      navigate("/login");
    }
  };

  // Safely get username for display
  const displayName = user?.username || "User";

  return (
    <header className="header">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="logo">
              <img src={logo} alt="ONGC Logo" />
            </div>
          </div>
          <div className="col-3 text-end">
            <div className="d-flex justify-content-start align-items-center">
              <a href="/" className="text-decoration-none text-dark me-4">
                Dashboard
              </a>
              <span className="me-4">|</span>
              <a
                href="/viewbookings"
                className="text-decoration-none text-dark me-4"
              >
                Bookings
              </a>
              <span className="me-4">|</span>

              <div className="dropdown d-inline-block position-static">
                <a
                  href="#"
                  className="text-decoration-none text-dark me-4 dropdown-toggle"
                  id="reportsDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  data-bs-auto-close="outside"
                  data-bs-display="static"
                >
                  Reports
                </a>
                <ul
                  className="dropdown-menu shadow"
                  aria-labelledby="reportsDropdown"
                  style={{
                    zIndex: 1050,
                    position: "absolute",
                  }}
                >
                  <li>
                    <a className="dropdown-item" href="/reports/property-wise">
                      Property Wise
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/reports/employee-wise">
                      Employee Wise
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-3 text-end">
            <div className="d-flex justify-content-end align-items-center">
              <div className="user-profile">
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 0C7.163 0 0 7.163 0 16C0 24.837 7.163 32 16 32C24.837 32 32 24.837 32 16C32 7.163 24.837 0 16 0ZM16 4.8C18.884 4.8 21.2 7.116 21.2 10C21.2 12.884 18.884 15.2 16 15.2C13.116 15.2 10.8 12.884 10.8 10C10.8 7.116 13.116 4.8 16 4.8ZM16 27.6C12.2 27.6 8.826 25.816 6.8 23.048C6.863 19.524 13.6 17.6 16 17.6C18.384 17.6 25.137 19.524 25.2 23.048C23.174 25.816 19.8 27.6 16 27.6Z"
                    fill="#4A6387"
                  />
                </svg>

                <div className="dropdown">
                  <button
                    className="btn btn-link text-decoration-none text-dark dropdown-toggle"
                    type="button"
                    id="userDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {displayName}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="userDropdown">
                    <li>
                      <a className="dropdown-item" href="/change-password">
                        Change Password
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleLogout}
                      >
                        Logout
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
